import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/colors.css'
import './assets/styles/base.css'

const app = createApp(App)

app.use(router)

app.mount('#app')

// Register service worker for basic caching (not full PWA)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
